import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export function deleteChatBackgroundForEntity(entityId: string): void {
  const userId = Entities.usersStore.myId;
  if (!userId) {
    return;
  }
  Entities.appearance.deleteChatBackgroundForEntity(entityId);
  storage.chatBackgroundsByEntity.remove(entityId, userId);
}
